module.exports = __webpack_public_path__ + "img/H000050_pencil.38eeab50.png";